module.exports = __webpack_public_path__ + "static/media/c8bannerModulE_small.1c848724.jpg";